import React from 'react'

import { Icon, Search, TextInput } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, object, string } from 'prop-types'

function FilterSearchInput({
  id,
  value,
  onChange,
  placeholder,
  ariaLabel = null,
  inputRef = null,
  className = '',
}) {
  const handleChange = (event) => onChange(event.target.value)
  const wrapperClassName = ['filter-wrapper__search', className].filter(Boolean).join(' ')

  return (
    <TextInput
      id={id}
      isPilot
      size="medium"
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      aria-label={ariaLabel}
      leadIcon={<Icon notSpaced svgComponent={Search} color="dark" />}
      textInputClassName="filter-wrapper__search-input"
      wrapperClassName={wrapperClassName}
      innerRef={inputRef}
    />
  )
}

FilterSearchInput.propTypes = {
  id: string.isRequired,
  value: string.isRequired,
  onChange: func.isRequired,
  placeholder: string.isRequired,
  ariaLabel: string,
  inputRef: object,
  className: string,
}

export default FilterSearchInput
